import { getPersonalDetailsFromLocalStorage } from '../commonfunctions/helper'

const initialState = {
  name: getPersonalDetailsFromLocalStorage()
    ? getPersonalDetailsFromLocalStorage().name
    : '',
  email: getPersonalDetailsFromLocalStorage()
    ? getPersonalDetailsFromLocalStorage().email
    : '',
  mobile: getPersonalDetailsFromLocalStorage()
    ? getPersonalDetailsFromLocalStorage().mobile
    : '',
  age: getPersonalDetailsFromLocalStorage()
    ? getPersonalDetailsFromLocalStorage().age
    : '',
  gender: getPersonalDetailsFromLocalStorage()
    ? getPersonalDetailsFromLocalStorage().gender
    : ''
}
const personaldetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'CHANGE_PERSONAL_DETAIL_NAME':
      return { ...state, name: action.value }
    case 'CHANGE_PERSONAL_DETAIL_EMAIL':
      return { ...state, email: action.value }
    case 'CHANGE_PERSONAL_DETAIL_MOBILE':
      return { ...state, mobile: action.value }
    case 'CHANGE_PERSONAL_DETAIL_AGE':
      return { ...state, age: action.value }
    case 'CHANGE_PERSONAL_DETAIL_GENDER':
      return { ...state, gender: action.value }

    default:
      return { ...state }
  }
}
export default personaldetailsReducer
